import React from "react"
import styled from "styled-components"
import BreakpointUp from "../Media/BreakpointUp"
import PersonalInformationProductForm from "../PersonalInformationProductForm"
import BuildingRequirment from "../BuildingRequirment"
const SectionGrid = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
  ${BreakpointUp.xl`
        margin-right: -50px;
        margin-left: -50px;
    `}
`
const SectionGridCol = styled.div`
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  ${BreakpointUp.lg`
        flex: 0 0 50%;
        max-width: 50%;
    `}
  ${BreakpointUp.xl`
        padding-right: 50px;
        padding-left: 50px;
    `}
    &:first-child {
    &:before {
      display: none;
    }
  }
  &:before {
    content: "";
    display: none;
    position: absolute;
    top: 0;
    left: -1px;
    background-color: #dbdbdb;
    height: 100%;
    width: 1px;
    ${BreakpointUp.lg`
            display:block;
        `}
  }
`
const CardInfo = styled.div`
  position: relative;
  margin-bottom: 30px;
`
const CardInfoBody = styled.div`
  margin: 0;
`
const CardInfoTitle = styled.h2`
  color: #000;
  font-weight: 900;
  text-align: center;
  margin-bottom: 0;
  font-size: 20px;
  line-height: 30px;
  @media (min-width: 768px) {
    font-size: 24px;
    line-height: 34px;
  }
  @media (min-width: 992px) {
    font-size: 28px;
    line-height: 38px;
  }
`
const CardInfoLead = styled.p`
  text-align: center;
  margin-bottom: 30px;
`
const CustomBuildingQuote = ({ states, location }) => {
  return (
    <>
      <SectionGrid>
        <SectionGridCol>
          <CardInfo>
            <CardInfoBody>
              <CardInfoTitle>Select Your Building Requirements</CardInfoTitle>
              <CardInfoLead></CardInfoLead>
              <BuildingRequirment />
            </CardInfoBody>
          </CardInfo>
        </SectionGridCol>
        <SectionGridCol>
          <CardInfo>
            <CardInfoBody>
              <CardInfoTitle>Your Contact Details</CardInfoTitle>
              <CardInfoLead></CardInfoLead>
              <PersonalInformationProductForm states={states} location={location} />
            </CardInfoBody>
          </CardInfo>
        </SectionGridCol>
      </SectionGrid>
    </>
  )
}

export default CustomBuildingQuote
